const base = require('base/product/base');
const baseImported = require('./baseImportedFunctions');
const commonHelpers = require('../helpers/commonHelpers');
const recetaHelpers = require('./recetaHelpers');
const formSelects = 'div.subscription-pdp form.configLensForm select.item-selector';

/**
 * @description - resets the RepeatOrder section if no products to be reorder are left
 */
function resetRepeatOrderSection() {
    $('.repeat-order-result').empty();
    $('.contacto-add-to-cart').removeClass('d-none');
    recetaHelpers.canBeAddedToCart();
}

function enableOptionDefaultFormRecipeFlowStore() {
    if ($("input[name='isFlowStoreSubscription']").data('flow-store-subscription')) {
        for (let i = 0; i < $(formSelects).length; i++) {
            $(formSelects)[i].selectedIndex = 0;
        }
    }  
}

/**
 * @description - based on the products displayed on the UI, it generates the data to be submited to the Cart-AddProduct method
 * @param {string} pid - the PDP product sku
 * @param {string} tipoProducto - the type of the PDP product
 * @returns {object} - the information to be submited to Cart-AddProduct method
 */
function generateFormToAdd(pid, tipoProducto) {
    const form = {};
    const setPids = [];

    $('.ordered-product').each(function(idx, elem) {
        const prodQuantity = Number($(elem).find('.quantity-form .ordered-product-quantity').val());
        const prodObj = {
            pid: $(elem).data('sku'),
            qty: prodQuantity,
            selectedEye: $(elem).data('eyeSide'),
            rykCustom: {
                recetData: JSON.stringify($(elem).data('recipe')),
                tipoProducto: 'lenteContacto'
            }
        };

        const eyeData = {Cantidad: prodQuantity, cyl: '0,0'};
        const lefEyeData = $(elem).data('eyeSide') === 'Derecho' ? { } : eyeData;
        const rightEyeData = $(elem).data('eyeSide') === 'Derecho' ? eyeData : { };
        prodObj.rykCustom.recetDataContacto = {
            ojoIzquierdo: lefEyeData,
            ojoDerecho: rightEyeData
        };

        setPids.push(prodObj);
    });

    form.pid = pid;
    form.tipoProducto = tipoProducto;

    try {
        form.pidsObj = JSON.stringify(setPids);
    } catch(e) {  }

    return form;
}

/**
 * @description - it displays/hides the error section of the repeat Order RUT input
 * @param {string} msg - the message to be displayed
 * @param {boolean} show - determines if the message section should be displayed or hided
 */
function toggleError(msg, show) {
    $('.repeat-order-error.container-msj .content-msj span').html(msg);

    if(show) {
        $('.repeat-order-error.container-msj').addClass('error');
        $('div.buy-one-pdp .repeat-order-input input').addClass('invalid');
    } else {
        $('.repeat-order-error.container-msj').removeClass('error');
        $('div.buy-one-pdp .repeat-order-input input').removeClass('invalid');
    }
}

/**
 * @description - calcaultes the RepeatOrder subtotals
 */
function calculateSubtotals() {
    let totalSalesPrices = 0;
    let totalListPrice = 0;
    let discount = 0;

    $('.ordered-product').each(function(index, elem) {
        const quantity = $(elem).find('.line-item-quantity .ordered-product-quantity.custom-select').val();
        const listPrice = $(elem).data('main-product-base-price');
        const salesPrice = $(elem).data('main-product-price');

        totalSalesPrices += salesPrice ? (Number(salesPrice) * quantity) : 0;
        totalListPrice += listPrice ? (Number(listPrice) * quantity) : 0;
    });

    if(totalListPrice > 0 && totalSalesPrices > 0 && totalListPrice !== totalSalesPrices) {
        discount = totalListPrice - totalSalesPrices;
    }

    discount = Math.round(discount * 100) / 100;
    $('.subtotal-discount span').html(commonHelpers.formatMoneyToClp(discount));

    if(discount && discount > 0) {
        $('.subtotal-discount span').removeClass('d-none');
    } else {
        $('.subtotal-discount span').addClass('d-none');
    }

    totalSalesPrices = Math.round(totalSalesPrices * 100) / 100;
    $('.subtotal-amount span').html(commonHelpers.formatMoneyToClp(totalSalesPrices));
}

$('#repeat-order-rut').on('keypress', function(event){
  return (event.charCode >= 48 && event.charCode <= 57) || (event.charCode === 75 || event.charCode === 107);
});

$(document).on('change', '.ordered-product .ordered-product-quantity.custom-select', function(ev) {
    const quantitySelectorChanged = $(ev.currentTarget);
    const quantitySelected = Number(quantitySelectorChanged.val());
    const orderedProduct = $(quantitySelectorChanged.parents('.ordered-product'));
    const listPrice = orderedProduct.data('mainProductBasePrice');
    const salesPrice = orderedProduct.data('mainProductPrice');
    const orderedProductPos = orderedProduct.data('position');
    const pricesElem = $('.subtotal-product[data-position="' + orderedProductPos + '"]');
    let totalListPrice;
    let totalSalesPrice;

    if(listPrice) {
        totalListPrice = listPrice * quantitySelected;
    }

    if(salesPrice) {
        totalSalesPrice = salesPrice * quantitySelected;
    }

    pricesElem.find('.price .sales span').html(commonHelpers.formatMoneyToClp(totalListPrice ? totalListPrice : totalSalesPrice));
    calculateSubtotals();
});

$('.repeat-order-result').on('click', '.ordered-product .remove-product', function (e) {
    const orderedProduct = $(e.currentTarget).parents('.ordered-product');
    const orderedProductPosition = $(orderedProduct).data('position');
    $('.subtotal-product[data-position="' + orderedProductPosition +'"]').remove();
    orderedProduct.remove();

    calculateSubtotals();

    if($('.ordered-product').length === 0) {
        resetRepeatOrderSection();
    }
});

$(document).on('click', '.add-repeated-products:not(.has-subscription)', function(e) {
    const addToCartUrl = baseImported.getAddToCartUrl();

    if(addToCartUrl) {
        const  productType = $('[data-tipo-producto]').val();
        const pid = baseImported.getPidValue($(this));
        const form = generateFormToAdd(pid, productType);

        $.spinner().start();

        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: form,
            success: function (data) {
                baseImported.handlePostCartAdd(data);
                $('body').trigger('product:afterAddToCart', data);
                $.spinner().stop();
                base.miniCartReportingUrl(data.reportingURL);
                $('.close.cristales').trigger('click');
                if (data.modalContentTemplate) {
                    $('.modal-content.cristales__equal-modal-spacing').html(data.modalContentTemplate);
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
});

$(document).on('click', 'div.buy-one-pdp .repeat-order-search-button', function (e) {
    e.preventDefault();
    const getLastOrderUrl = $('[data-url-get-last-order]').data('url-get-last-order');

    if(!getLastOrderUrl) {
        return false;
    }

    $('.repeat-order-result').empty();
    let repeatOrderRut = $('#repeat-order-rut').val();
    const regex = new RegExp($('#repeat-order-rut').prop('pattern'), "gi");

    if (!regex.test(repeatOrderRut)) {
        const msg = $('#repeat-order-rut').data('error-rut');
        toggleError(msg, true);
        return false;
    }

    toggleError('', false);

    repeatOrderRut = repeatOrderRut.slice(0, repeatOrderRut.length - 1) + '-' + repeatOrderRut.slice(repeatOrderRut.length - 1);

    $.spinner().start();

    $.ajax({
        url: getLastOrderUrl,
        method: 'GET',
        data: {repeatOrderRut: repeatOrderRut},
        success: function (response) {
            if(response.success) {
                $('.repeat-order-result:not(.repeat-order-result-subscription)').html(response.data);
                if($('.ordered-product').length > 0) {
                    $('.repeat-order-buttons .add-repeated-products').prop('disabled', false);
                    $('.contacto-add-to-cart').addClass('d-none');
                }
            } else {
                $('.repeat-order-error.container-msj').html(response.data);
                $('.repeat-order-error.container-msj').addClass('error');
                $('.repeat-order-input input').addClass('invalid');
            }

            $.spinner().stop();
        },
        error: function (err) {
            $('.repeat-order-buttons .add-repeated-products').prop('disabled', true);
            $.spinner().stop();
        }
    });
});

module.exports = {
    methods: {
        generateFormToAdd: generateFormToAdd,
        enableOptionDefaultFormRecipeFlowStore : enableOptionDefaultFormRecipeFlowStore
    }
}